import { Injectable } from "@angular/core";
import { UserRoleEnum } from "../enums/enums";
import { StorageService } from "../modules/shared/services/storage.service";
import { RoleDTO } from "../interfaces/base-entity";
import { TranslationService } from "../services/translation.service";

@Injectable({
  providedIn: 'root'
})
export class UserRoleService {


  constructor(
    private storage: StorageService,
    private translationService: TranslationService
  ) { }

  private loadUserRoles(): void {
   
  
  }


  getRoleEnum(): UserRoleEnum {
    const role = this.storage.getItem('currentRole', false) as RoleDTO;
    if (!role || role.roleId == null) {
      return UserRoleEnum.Employee;
    }
    const roleId = Number(role.roleId);
    const knownRoles = Object.values(UserRoleEnum).filter(v => typeof v === 'number') as number[];
    if (!knownRoles.includes(roleId)) {
      return UserRoleEnum.Employee;
    }
    return roleId as UserRoleEnum;
  }

  getRole(): RoleDTO | null {
    const role = this.storage.getItem('currentRole', false) as RoleDTO;
    if (role) {
      return {
        ...role,
        roleName: this.translationService.getRoleNameInSpanish(role.roleName || ''),
        description: this.translationService.getRoleNameInSpanish(role.roleName || '')
      };
    }
    return role;
  }

  /**
   * Obtiene el rol con traducción asíncrona (método recomendado)
   */
  async getRoleAsync(): Promise<RoleDTO | null> {
    const role = this.storage.getItem('currentRole', false) as RoleDTO;
    if (role) {
      const translatedRoleName = await this.translationService.translateRoleAsync(role.roleName || '');
      return {
        ...role,
        roleName: translatedRoleName,
        description: translatedRoleName
      };
    }
    return role;
  }
}
   